import axios from 'axios';

const instance = axios.create({
    baseURL: "http://api.tikplan.com/api/Customer",
    headers: {
        'Content-Type': 'application/json',
        'Agency': '3E9F5B53-BF6F-432F-B7B5-A3410F98DC3C',
        'DeviceId': navigator.productSub,
        'DeviceName': navigator.vendor,
        'OS': navigator.platform,
    }
})

export default instance;